const saunaSlides   = document.querySelectorAll(".sauna-slide");
const saunaDots     = document.querySelectorAll(".sauna-section__dot");
const saunaMedia    = document.querySelector(".sauna-section__media");
const saunaTitle    = document.querySelector("[data-sauna-title]");
const saunaPrevBtn  = document.querySelector("[data-sauna-prev]");
const saunaNextBtn  = document.querySelector("[data-sauna-next]");

const FADE_DURATION     = 500;      // ms - crossfade speed
const FADE_EASING       = "linear"; // matches Slick's cssEase: "linear"
const AUTOPLAY_INTERVAL = 5000;     // ms - time each slide stays visible

let currentIndex = 0;
let autoSlideInterval = null;
let resumeTimeout = null;
let isTransitioning = false;

// Build two stacked background layers for a true simultaneous crossfade
let layerA, layerB, activeLayer;

if (saunaMedia) {
  var computedPosition = window.getComputedStyle(saunaMedia).position;
  if (computedPosition === "static") {
    saunaMedia.style.position = "relative";
  }

  layerA = document.createElement("div");
  layerB = document.createElement("div");

  [layerA, layerB].forEach(function (layer) {
    layer.style.position = "absolute";
    layer.style.top = "0";
    layer.style.left = "0";
    layer.style.right = "0";
    layer.style.bottom = "0";
    layer.style.backgroundSize = "cover";
    layer.style.backgroundPosition = "center";
    layer.style.backgroundRepeat = "no-repeat";
    layer.style.transition = "opacity " + FADE_DURATION + "ms " + FADE_EASING;
    saunaMedia.appendChild(layer);
  });

  layerA.style.opacity = "1";
  layerB.style.opacity = "0";
  activeLayer = layerA;

  saunaMedia.style.backgroundImage = "none";
}

function setMediaImage(img, animate) {
  if (!saunaMedia || !img) return;

  var incomingLayer = activeLayer === layerA ? layerB : layerA;
  incomingLayer.style.backgroundImage = "url(" + img + ")";

  if (!animate) {
    layerA.style.transition = "none";
    layerB.style.transition = "none";
    incomingLayer.style.opacity = "1";
    activeLayer.style.opacity = "0";
    void incomingLayer.offsetWidth;
    layerA.style.transition = "opacity " + FADE_DURATION + "ms " + FADE_EASING;
    layerB.style.transition = "opacity " + FADE_DURATION + "ms " + FADE_EASING;
    activeLayer = incomingLayer;
    return;
  }

  incomingLayer.style.opacity = "1";
  activeLayer.style.opacity = "0";
  activeLayer = incomingLayer;
}

function setTitle(text) {
  if (!saunaTitle) return;
  if (text && text.trim() !== "") {
    saunaTitle.textContent = text;
    saunaTitle.style.display = "";
  } else {
    saunaTitle.style.display = "none";
  }
}

function goToSlide(index, animate) {
  if (animate === undefined) animate = true;
  if (isTransitioning) return;
  if (index === currentIndex && saunaSlides[index].classList.contains("is-active")) return;

  isTransitioning = true;

  var incomingSlide = saunaSlides[index];
  var img = incomingSlide.dataset.image;
  var title = incomingSlide.dataset.title;

  saunaSlides.forEach(function (slide) { slide.classList.remove("is-active"); });
  saunaDots.forEach(function (dot) { dot.classList.remove("is-active"); });

  incomingSlide.classList.add("is-active");
  saunaDots[index].classList.add("is-active");

  setMediaImage(img, animate);
  setTitle(title);

  currentIndex = index;

  setTimeout(function () {
    isTransitioning = false;
  }, animate ? FADE_DURATION : 0);
}

function nextSlide() {
  var next = (currentIndex + 1) % saunaSlides.length;
  goToSlide(next);
}

function prevSlide() {
  var prev = (currentIndex - 1 + saunaSlides.length) % saunaSlides.length;
  goToSlide(prev);
}

function stopAutoSlide() {
  if (autoSlideInterval) {
    clearInterval(autoSlideInterval);
    autoSlideInterval = null;
  }
  if (resumeTimeout) {
    clearTimeout(resumeTimeout);
    resumeTimeout = null;
  }
}

function startAutoSlide(interval) {
  if (interval === undefined) interval = AUTOPLAY_INTERVAL;
  stopAutoSlide();
  autoSlideInterval = setInterval(nextSlide, interval);
}

saunaDots.forEach(function (dot) {
  dot.addEventListener("click", function () {
    stopAutoSlide();
    goToSlide(Number(dot.dataset.slide));
    resumeTimeout = setTimeout(function () {
      resumeTimeout = null;
      startAutoSlide();
    }, 5000);
  });
});

// Arrow navigation (prev/next)
if (saunaPrevBtn) {
  saunaPrevBtn.addEventListener("click", function () {
    stopAutoSlide();
    prevSlide();
    resumeTimeout = setTimeout(function () {
      resumeTimeout = null;
      startAutoSlide();
    }, 5000);
  });
}

if (saunaNextBtn) {
  saunaNextBtn.addEventListener("click", function () {
    stopAutoSlide();
    nextSlide();
    resumeTimeout = setTimeout(function () {
      resumeTimeout = null;
      startAutoSlide();
    }, 5000);
  });
}

// Initialize first slide instantly (no crossfade on page load)
saunaSlides[0].classList.add("is-active");
saunaDots[0].classList.add("is-active");
if (saunaMedia && saunaSlides[0].dataset.image) {
  setMediaImage(saunaSlides[0].dataset.image, false);
}
setTitle(saunaSlides[0].dataset.title);
startAutoSlide();